var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assignment)?_c('div',{class:_vm.attendanceClass(_vm.assignment)},[_vm._v("\n    "+_vm._s(_vm.assignment.name)+"\n    "),(_vm.assignment.mucie)?_c('font-awesome-icon',{attrs:{"icon":"music"}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }